import { Box, Typography } from "@mui/joy";
import React, { useState } from "react";
import { theme } from "styles/theme";
import { LoginMethod } from "recoil/loginHintAtom";
import { LoginButtonLayout } from "./loginButtonLayout";

// Figma 8510:34299 Icon/Chevron — 익스포트 자산 지오메트리를 아래 방향으로 회전해 커밋
const ChevronDownSvg = ({ color = "currentColor" }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.125 6.5625L9 11.4375L13.875 6.5625"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// 소셜 로그인 버튼 접힘 영역 (Figma 8529-15562).
// 접힘 상태에선 대표 버튼(order[0])만 + "다른 방법으로 시작하기 ⌄" 토글,
// 탭하면 나머지 버튼이 펼쳐지고 토글은 사라진다(단방향, 마운트마다 접힘으로 리셋).
// layout.collapsible=false(iOS 앱)면 전체 버튼을 순서대로 렌더만 한다.
export default function CollapsibleLoginButtons({
  layout,
  buttonByMethod,
}: {
  layout: LoginButtonLayout;
  buttonByMethod: Record<LoginMethod, JSX.Element>;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const visibleMethods =
    layout.collapsible && !isExpanded ? [layout.order[0]] : layout.order;

  return (
    <>
      {visibleMethods.map((method) => (
        <React.Fragment key={method}>{buttonByMethod[method]}</React.Fragment>
      ))}
      {layout.collapsible && !isExpanded && (
        <Box
          component="button"
          type="button"
          aria-expanded={false}
          onClick={() => setIsExpanded(true)}
          sx={{
            border: "none",
            background: "transparent",
            p: 0,
            cursor: "pointer",
            width: "100%",
            height: "46px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              height: "2px",
              borderRadius: "2px",
              backgroundColor: theme.vars.palette.Border.Weak,
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "2px",
              pl: "4px",
            }}
          >
            <Typography
              variant="Caption"
              sx={{
                color: theme.vars.palette.Content.Weak,
                fontWeight: 500,
              }}
            >
              다른 방법으로 시작하기
            </Typography>
            <ChevronDownSvg color={theme.vars.palette.Content.SuperWeak} />
          </Box>
          <Box
            sx={{
              flex: 1,
              height: "2px",
              borderRadius: "2px",
              backgroundColor: theme.vars.palette.Border.Weak,
            }}
          />
        </Box>
      )}
    </>
  );
}
